<template>
        <b-container fluid="md" class="pl-3 pl-md-0 pl-xl-3 pt-0 pb-4 pr-0" v-if="info">
            <b-row v-if="description">
                <b-col cols="11" md="11" xl="11" class="description_top pt-3 pl-4 pr-4" v-html="description[0]" />
            </b-row>
            <b-row class="mt-5" v-if="description">
                <b-col cols="11" md="6" xl="4" class="description pt-3 pl-0 pl-sm-3 pl-xl-0" v-html="description[1]" />
                <b-col cols="12" xl="8" class="image_description pl-0 pl-sm-1 pr-0 mt-3  mt-xl-0">
                    <img :src="(getTheme=='light-theme')?info.image_description.path:(info.image_description_dark)?info.image_description_dark.path:info.image_description.path" v-if="info.image_description"  >
                </b-col>
            </b-row>
        </b-container>
</template>

<script>
    export default {
        name: "Description",
        computed: {
            info: function () {
                return this.$store.getters.allPages;
            },
            getTheme() {
                return this.$store.getters.userTheme
            },
            description: function(){
                return this.info.description.split("<hr>");
            }
        }
    }
</script>

<style scoped>

    .description_top {
        font-family: SF, sans-serif;
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        color: var(--text-secondary-color);
        background-color: var(--background-color-secondary);
    }
    .description {
        font-family: SF, sans-serif;
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        color: var(--text-secondary-color);
    }

    .image_description img {
        margin-left: -8px;
        width: 100%;
        max-width: 800px !important;
    }

</style>